<template>
  <BasicModalWindow
    ref="modal_element"
    class="message-move"
    title="folders.select_folders"
    @modalWindowClose="onSelectCancel()"
  >
      <template #pre-body v-if="folders_collapse_collection.count > 0">
        <InputSearch
            ref="input_search_component"
            class="contacts-search"
            @inputSearchSet='onInputSearchSet'
            @inputSearchClear='onInputSearchClear'
        />
      </template>

      <template #body>
          <FoldersListCollapsable v-if="folders_search_collection.search_active === false && folders_collapse_collection.count > 0"
            selection_box="check"
            list_type="selection"
            :folders_collapse_collection='folders_collapse_collection'
            :folders_selection_collection='folders_selection_collection'
            @folderSelect="onFoldersSelect"
          />

          <FoldersListSearch v-else-if="folders_search_collection.count > 0"
            selection_box="check"
            list_type="selection"
            :folders_search_collection='folders_search_collection'
            :folders_selection_collection='folders_selection_collection'
          />

          <ContentEmpty v-else
            text="folders.empty_folders"
            icon="fas fa-folder"
          />
      </template>

      <template #footer>
           <ActionButton
              @click="onSelectSubmit()"
              icon="fa fa-folder-open"
              class='main-action push-right'
              :disabled="!folders_selection_collection.count"
              :text="button_text"
          />
      </template>
  </BasicModalWindow>
</template>

<script setup>
  import {ref, reactive}             from 'vue';
  import {defineProps, defineEmits}  from 'vue';
  import {onBeforeMount}             from 'vue';
  import FoldersListCollapsable      from '../Partials/FoldersListCollapsable.vue';
  import FoldersListSearch           from '../Partials/FoldersListSearch.vue';
  import BasicModalWindow            from '@/vue/Layouts/Modals/BasicModalWindow.vue';
  import ActionButton                from '@/vue/Elements/Buttons/ActionButton.vue'
  import InputSearch                 from '@/vue/Elements/Inputs/InputSearch.vue'
  import ContentEmpty                from '@/vue/Elements/Content/ContentEmpty.vue';
  import FoldersController           from '@/js/Mailboxes/FoldersController';
  import FoldersCollapseCollection   from '@/js/Mailboxes/Collections/FoldersCollapseCollection';
  import FoldersSearchCollection     from '@/js/Mailboxes/Collections/FoldersSearchCollection';

  const props = defineProps({
    folders_selection_collection : {
      required: true,
    },

    button_text : {
      default : "folders.actions.move"
    }
  })

  const emit = defineEmits([
    'folderSelectCancel', 'foldersSelectSubmit'
  ])

  const modal_element            = ref();
  const input_search_component   = ref();

  const folders_controller           = FoldersController
  const folders_search_collection    = reactive(new FoldersSearchCollection());
  const folders_collapse_collection  = reactive(new FoldersCollapseCollection('select_all_modal'));

  onBeforeMount(() => {
    setCollectionLists();
  })

  const onFoldersSelect = (folder) => {
    if (folder.id === 'YWxsAA') {
      props.folders_selection_collection.reset();
      props.folders_selection_collection.add(folder);
      return;
    }

    props.folders_selection_collection.delete('YWxsAA');
  }

  const onSelectSubmit = () => {
    emit('foldersSelectSubmit');
  }

  const onSelectCancel = () => {
    emit('foldersSelectCancel');
  }

  const onInputSearchSet = (term) => {
    folders_search_collection.search(term);
  }

  const onInputSearchClear = (term) => {
    folders_search_collection.reset();
  }

  const setCollectionLists = () => {
    folders_collapse_collection.setModifier('add_all_folders');
    folders_collapse_collection.setFolders(folders_controller.mailboxes.folders.all);
    folders_search_collection.setSearchList(folders_controller.mailboxes.folders.all);
  }
</script>
